/**
 * Roles, and what each one is allowed to do.
 *
 * This is deliberately not a ladder. A restaurant manager is not above or below
 * a company manager — they answer to different organisations and see different
 * data. Asking "is this role senior enough" cannot express that, so guards ask
 * "does this role hold this permission" instead.
 */
export const ROLES = [
    'super_admin',
    'company_admin',
    'dept_admin',
    'employee',
    'guest',
    'restaurant_admin',
];
/** Which organisation a role belongs to. Decides how far its reads extend. */
export const SCOPES = ['platform', 'company', 'restaurant'];
export const ROLE_SCOPE = {
    super_admin: 'platform',
    company_admin: 'company',
    dept_admin: 'company',
    employee: 'company',
    guest: 'company',
    restaurant_admin: 'restaurant',
};
export const ROLE_LABELS = {
    super_admin: 'System admin',
    company_admin: 'Company admin',
    dept_admin: 'Department admin',
    employee: 'Employee',
    guest: 'Guest',
    restaurant_admin: 'Restaurant admin',
};
/** Roles that belong to the customer company rather than a restaurant. */
export function isCompanyRole(role) {
    return ROLE_SCOPE[role] === 'company';
}
export function isRestaurantRole(role) {
    return ROLE_SCOPE[role] === 'restaurant';
}
//# sourceMappingURL=roles.js.map